// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oSuH","col":"styles_col__KPpEj"};